import { action } from 'easy-peasy';
import { IResetCurrentShelterAction } from '../types';

const resetCurrentShelter: IResetCurrentShelterAction = action(state => {
  state.current = null;
});

export default resetCurrentShelter;
